module.exports = __webpack_public_path__ + "static/media/1001014HG.9cd8b35a.jpg";